import React from 'react'
import cn from 'classnames'
import styles from './styles.module.scss'
import {check, notCheck} from '../svg/dashboard/main'

export const Check = ({mode, className}) => {
  
  const classNames = cn(styles.checkBlock, styles[mode], className)
  
  
  return (
    <div className={classNames}>
      {mode === 'notComplete' ? notCheck : check}
    </div>
  )
}
